import { FluxData } from '@models/flux-data';
import { MapPoint } from '@models/map/map-point';
import { ClassCast } from '@utilities/object-helper';
import { UpStreamChannel } from '../up-stream-channel';

export class UsAlignmentData {
  username: string; // Here for model uniformity. necessary for referenceSweep.
  timestamp: number;
  node: string;
  name: string;
  altName: string;
  deviceName: string;
  deviceType: string;
  comments: string;
  @ClassCast(UpStreamChannel)
  channelList: UpStreamChannel[];
  tilt: number = 0;
  fluxData: FluxData;
  geoLocation: MapPoint;

  init() {
    this.channelList = Array.isArray(this.channelList) ? this.channelList.filter(Boolean) : [];
    if (!this.channelList.length) {
      this.tilt = 0;
      this.fluxData = new FluxData();
      return;
    }
    this.calcTilt(this.channelList);
    this.fluxDataBuilder(this.channelList);
  }

  fluxDataBuilder(channelList: UpStreamChannel[]): void {
    // Instantiate fluxdata class
    let fluxData: FluxData = new FluxData();
    if (!channelList.length) {
      this.fluxData = fluxData;
      return;
    }
    // Add base icfr
    fluxData.icfr = channelList.reduce((icfr, channel) => {
      icfr.push(channel.icfr);
      return icfr;
    }, new Array<number>());

    // Add base frequency
    fluxData.frequency = channelList[0].frequency;

    channelList.forEach((channel: UpStreamChannel) => {
      // Combine all frequencies
      fluxData.frequencies = fluxData.frequencies.concat(channel.frequency);
      fluxData.bandwidths = fluxData.bandwidths.concat(channel.bandwidth);

      // Combine all data points into single array
      fluxData.icfrGraphPoints.push(Array.isArray(channel.icfrPoints) ? channel.icfrPoints : []);
      fluxData.phaseGraphPoints.push(Array.isArray(channel.phasePoints) ? channel.phasePoints : []);
      fluxData.delayGraphPoints.push(Array.isArray(channel.groupDelayPoints) ? channel.groupDelayPoints : []);
    });

    this.fluxData = fluxData;
  }

  calcTilt(channelList: UpStreamChannel[]) {
    let highTx: number = 0;
    let lowTx: number = 0;
    let bandwidth: UpStreamChannel[];
    channelList.forEach(channel => {
      if (channel.bandwidth === null) {
        channel.bandwidth = 6.4;
      }
    })
    // For tilt calculation it should be -> Tx value of Highest 6.4MHz wide Frequency  - Tx value of Lowest 6.4MHz wide Frequency = US Tilt.
    bandwidth = channelList.filter(value => value.bandwidth === 6.4)
               .sort((a,b) => a.frequency - b.frequency);

    bandwidth = bandwidth.filter(value => Number.isFinite(Number(value.txPower)));
    if (!bandwidth.length) {
      this.tilt = 0;
      return;
    }

    lowTx = Number(bandwidth[0].txPower.toFixed(1));
    highTx = Number(bandwidth[bandwidth.length - 1].txPower.toFixed(1));

    this.tilt = Number((highTx - lowTx).toFixed(2));
  }
}
